import { render } from "./PresenceList.vue?vue&type=template&id=dd503ae0"
import script from "./PresenceList.vue?vue&type=script&lang=js"
export * from "./PresenceList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__